import React, { useState } from 'react';
import { FiZap } from 'react-icons/fi';
import { getMacSsoToken } from '../../services/workflowService';
import '../../styles/MacSubscribePrompt.css';

const MacSubscribePrompt: React.FC = () => {
  const [loading, setLoading] = useState(false);

  const handleSubscribe = async () => {
    setLoading(true);
    try {
      const amsToken = localStorage.getItem('amsToken') ?? '';
      const ssoToken = await getMacSsoToken(amsToken);
      window.open(
        `${(process.env.REACT_APP_FUSIONNOW_APP_URL)}/now-certs-auth?token=${encodeURIComponent(ssoToken)}&redirectfrom=myamp&signup=true`,
        '_blank'
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className='mk-empty'>
      <FiZap size={32} className='mac-subscribe-prompt__icon' />
      <p className='mk-empty__title'>You are not currently a MAC subscriber</p>
      <p className='mk-empty__sub'>
        Subscribe to MAC to access workflows, recipes, and apps.
      </p>
      <button
        className='mk-subscribe-btn'
        onClick={handleSubscribe}
        disabled={loading}
      >
        {loading ? 'Loading…' : 'Subscribe to MAC'}
      </button>
    </div>
  );
};

export default MacSubscribePrompt;

